import {
  ChipField,
  DateField,
  EditButton,
  EmailField,
  List as RaList,
  TextField,
} from "react-admin";
import {
  Datagrid,
  ImpersonateUserButton,
  LongTextField,
} from "ra-friendsofbabba";

import Filters from "./Filters";
import React from "react";

const List = (props) => (
  <RaList
    {...props}
    filters={<Filters />}
    exporter={false}
    sort={{ field: "id", order: "desc" }}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
      <TextField
        source="profile.name"
        sortBy="UserProfiles.name"
        variant="body2"
      />
      <TextField
        source="profile.surname"
        sortBy="UserProfiles.surname"
        variant="body2"
      />
      <EmailField source="email" />
      <LongTextField source="universities" />
      <DateField source="last_login" showTime />
      <ChipField source="status" />
      <ImpersonateUserButton />
      <EditButton />
    </Datagrid>
  </RaList>
);

export default List;
